import { useBreakpointValue } from '@chakra-ui/react'

type UseIsMobile = (maxSize?: 'sm' | 'md' | 'lg' | 'xl' | '2xl') => boolean

const useIsMobile: UseIsMobile = (maxSize = 'sm') => useBreakpointValue({ base: true, [maxSize]: false })

export default useIsMobile
